export { WORKDAY_INTEGRATION_TYPE } from '../workdayPosition/constants';

/**
 * LaunchDarkly key for Workday's own hire form, camelCased by the LD SDK.
 *
 * A second key so the form can be rolled out after the position flow rather
 * than with it — but never *instead* of it: `create_hire` refuses an
 * application with no position, so `useWorkdayHire` requires both flags. On its
 * own this one does nothing.
 */
export const WORKDAY_HIRE_FLAG = 'tWorkdayHire';
